import React from "react";

// utils
import {createURLQuery} from '../utility/utils';

import useScreenSize from "../custonHooks/useScreenSize";


    const getAPIGWPath = (sRoute) => {
        const api_gw_url  = process.env.REACT_APP_API_GW_URL;
        let sPath =  api_gw_url + sRoute;
        return(sPath);

        // return(sRoute); // local testing with 4000
    }


    const getDBInstance = async (sRoute) => {  //'/rentals/inst'

        let sPath = getAPIGWPath(sRoute),
            srvResp,
            resJSON,
            data;

        try {
            srvResp = await fetch(sPath);
            resJSON = await srvResp.json();
            data    = await resJSON; 

            return(data);

        } catch(e) {
            console.log(e);
            alert('failed to generate db instance')
        }
    }


    const _getObjects_def = async (sType,aFilters) => {

        try {

        let oResult = {};
        
        // const api_ge_url  = process.env.REACT_APP_API_GW_DEV_URL;
        // const sPath        = api_ge_url + "/products";

        // local:
        const localePath  =  "/rentals/homes";
        const srvResponse = await fetch(localePath);
        const data        = await srvResponse.json();

        // let sortedData    = data.sort((a,b) => b.prod_id.localeCompare(a.prod_id));

        return(data);

        } catch(e) {
            console.log(e);
            alert('error could not fetch');
        }
    }

    /**
     * rnt: rentals
     * srv:services
     */ 
    // oFilterSetting, oURLQuery
  const _getObjects =  async (sType,oFilterSetting, iPage) => {
        
        let sRoute = '/rentals/homes', // to be dynamicly created based on sType param.
            oURLQuery,
            sPath,
            srvResp,
            oReqBdy, 
            resJSON, 
            data;

        oURLQuery  =  await createURLQuery(oFilterSetting.sortBy, iPage);
        sPath      = `${getAPIGWPath(sRoute)}?${oURLQuery.toString()}`;

        // Path
        // if(oURLQuery && oURLQuery.get('type')){
        //     sPath = `${sRoute}?${oURLQuery.toString()}`;
        // } else {
        //     sPath = sRoute;
        // }

        try{
            oReqBdy = {
                method : 'POST',
                body   : JSON.stringify({oFilterSetting}),
                headers: { 'Content-Type': 'application/json' }
            };

            srvResp = await fetch(sPath, oReqBdy);
            resJSON = await srvResp.json();
            data    = await resJSON;
            
            // format date:


            return(data);

        } catch(e) {
            alert('coulnt fetch documents count')
        }

    };

 const  _getObjectsCount =  async (sType, oFilterSetting) => {
   
        let sPath = getAPIGWPath('/filter/count'),
            srvResp,
            oReqBdy, 
            resJSON, 
            data;

        try{
            oReqBdy = {
                method : 'POST',
                body   : JSON.stringify({oFilterSetting}),
                headers: { 'Content-Type': 'application/json' }
            };

            srvResp = await fetch(sPath, oReqBdy);
            resJSON = await srvResp.json();
            data    = await resJSON; 

            return(data);

        } catch(e) {
            alert('coulnt fetch documents count')
        }
   }

   const _getObject = async (sID, sMediaSize) => {
        let sRoute = `/rentals/homes/${sID}`, // to be dynamicly created based on sType param.
            oURLQuery,
            sPath,
            srvResp,
            oReqBdy, 
            resJSON, 
            data;

        oURLQuery  =  await createURLQuery({meds:sMediaSize});
        // sPath      = getAPIGWPath(sRoute);
        sPath      = `${getAPIGWPath(sRoute)}?${oURLQuery.toString()}`;

        // Path
        // if(oURLQuery && oURLQuery.get('type')){
        //     sPath = `${sRoute}?${oURLQuery.toString()}`;
        // } else {
        //     sPath = sRoute;
        // }

        try{
            // oReqBdy = {
            //     method : 'POST',
            //     body   : JSON.stringify({oFilterSetting}),
            //     headers: { 'Content-Type': 'application/json' }
            // };

            srvResp = await fetch(sPath);
            resJSON = await srvResp.json();
            data    = await resJSON; 

            return(data);

        } catch(e) {
            alert('coulnt fetch documents count')
        }  
   }

   const createObject =  async (oEntry) => {

        let sPath = getAPIGWPath('/newItem/rental'), // to be dynamicly created based on sType param.
            oURLQuery,
            srvReq,
            srvResp,
            form_data,
            oReqBdy, 
            resJSON, 
            data;

        try {

            // prepare entry
            // form_data = new FormData();
            // form_data.append("entry", JSON.stringify(oEntry));

            // mediaFiles.map((oFile,i) => form_data.append('files[]',oFile) );


            // srvReq  = fetch(sPath, { method:'POST', body: JSON.stringify(oEntry), headers:{'Content-Type' : 'application/json' } });
            // srvReq  = fetch(sPath, { method:'POST', body: form_data, headers:{'Content-Type' : 'application/json' } });

            srvReq  = fetch(sPath, { method:'POST', body: JSON.stringify(oEntry), headers:{'Content-Type' : 'application/json' } });
            srvResp = await srvReq;
            data    = await srvResp.json();

            return(data);
            
        } catch(e) {
            console.log(e);
            alert('error. failed to create new object')
        }


   }

   const _mediaUpload =  async (mediaFiles,oEntry,sSize) => { //objID

        let sPath = getAPIGWPath('/aws_s3/mediaUpld'),
            srvResp,
            oReqBdy, 
            resJSON, 
            form_data,
            data;
        try{

            // testing using medium mediaSize
            sSize  ='medium'

            form_data = new FormData();

             form_data.append("entry", oEntry);

            mediaFiles.map((oFile,i) =>  form_data.append('files[]',oFile) );

            srvResp = await fetch( sPath, { method: 'POST', body: form_data });
            data    = await srvResp.json();

            return(data);

        } catch(e){
            console.log(e,"ERROR AWS UPLOAD");
            alert('Failed to upload media!');
        }
   }








export { getDBInstance, 
        _getObjects,
         _getObjectsCount,
         _mediaUpload,
         createObject,
         _getObject,
         getAPIGWPath
        }